<script setup>
import KdContainer from "./kdContainer.vue";
</script>

<template>
  <kd-container>
    <el-form :model="form" :rules="rules" ref="formRef" label-width="145px">
      <div v-for="(sItem, index) in form.suggestionItems" :key="index">
        <div class="suggestionTitle">
          <div>{{ sItem.staffName }}</div>
        </div>
        <div>

          <el-form-item label="临时措施" prop="`suggestionItems.${index}.provisionalMeasures`">
            <el-input v-model="sItem.provisionalMeasures" type="textarea" placeholder="请输入临时措施" disabled :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
          </el-form-item>

          <el-form-item
            label="永久方案"
            :prop="`suggestionItems.${index}.permanentSolution`"
            :rules="rules.permanentSolution"
          >
            <el-input
              :disabled="sItem && sItem.permanentSolution !== ''"
              placeholder="请输入永久方案"
              v-model="sItem.permanentSolution"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 4 }"
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item :prop="`suggestionItems.${index}.permanentSolution`">
            <file-upload-list
              ref="fileUploadList"
              :fileList="sItem.permanentSolutionFile"
            ></file-upload-list>
          </el-form-item>
          <el-form-item
            label="计划断点时间"
            :prop="`suggestionItems.${index}.planBreakpointTime`"
            :rules="rules.planBreakpointTime"
          >
            <el-date-picker
              :disabled="sItem && sItem.planBreakpointTime !== ''"
              type="date"
              v-model="sItem.planBreakpointTime"
              placeholder="请选择计划断点时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="完成情况"
            :prop="`suggestionItems.${index}.finishStatusInfo`"
            :rules="rules.finishStatusInfo"
          >
            <el-input
              :disabled="sItem && sItem.finishStatusInfo !== ''"
              placeholder="请输入完成情况"
              v-model="sItem.finishStatusInfo"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 4 }"
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item
            :prop="`suggestionItems.${index}.finishStatusInfoFiles`"
          >
            <file-upload-list
              ref="fileUploadList"
              :fileList="sItem.finishStatusInfoFiles"
            ></file-upload-list>
          </el-form-item>
          <el-form-item label="改进措施图片"
            :prop="`suggestionItems.${index}.provisionalMeasuresFile`"
          >
            <file-upload-list
              ref="fileUploadList"
              :fileList="sItem.provisionalMeasuresFile"
            ></file-upload-list>
          </el-form-item>


          <el-form-item
            label="实际断点时间"
            :prop="`suggestionItems.${index}.realityBreakpointTime`"
            :rules="rules.realityBreakpointTime"
          >
            <el-date-picker
              :disabled="sItem && sItem.realityBreakpointTime !== ''"
              type="date"
              v-model="sItem.realityBreakpointTime"
              placeholder="请选择实际断点时间"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item
            label="验证断点信息"
            :prop="`suggestionItems.${index}.checkStatusInfo`"
            :rules="rules.checkStatusInfo"
          >
            <el-input
              v-model="sItem.checkStatusInfo"
              type="textarea"
              placeholder="请输入验证断点信息"
              :autosize="{ minRows: 4, maxRows: 4 }"
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>

          <el-form-item
            label="验证断点时间"
            :prop="`suggestionItems.${index}.practicalBreakpointTime`"
            :rules="rules.practicalBreakpointTime"
          >
            <el-date-picker
              v-model="sItem.practicalBreakpointTime"
              type="date"
              placeholder="请选择验证断点时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <drag-upload
              ref="uploadFile"
              :accessoryList.sync="sItem.checkStatusInfoFiles"
              :httpRequest="imAction"
            />
          </el-form-item>
        </div>
      </div>

      <el-form-item>
        <el-button class="lang-but" type="primary" @click="auditPassBtClick"
          >通过</el-button
        >
        <el-button class="lang-but" type="danger" @click="auditRejectBtClick"
          >驳回</el-button
        >
      </el-form-item>
    </el-form>

    <kd-audit-pass-dialog
      :visible.sync="auditPassDialogVisible"
      v-model="form.auditText"
      @confirm="onAuditPassConfirm"
    />

    <div>
      <el-dialog
        width="600px !important"
        title="审核驳回"
        :visible.sync="dialogVisible"
      >
        <el-form
          :model="form"
          :rules="rules"
          ref="rejectFormRef"
          label-width="140px"
        >
          <div
            class="rejectUnitInfo"
            v-for="(item, index) in form.rejectItems"
            :key="index"
          >
            <div class="delButton">
              <el-button
                v-if="index !== 0"
                type="text"
                icon="el-icon-delete"
                @click="delRejectUser(index)"
                >删除</el-button
              >
            </div>
            <el-form-item
              label="驳回责任单位人员"
              :prop="`rejectItems.${index}.userId`"
              :rules="rules.userId"
            >
              <el-select
                filterable
                clearable
                v-model="item.userId"
                placeholder="请选择驳回责任单位人员"
              >
                <el-option
                  v-for="item in userOptions.filter(
                    (optionItem) =>
                      !form.rejectItems.some(
                        (rejectItem) => rejectItem.userId === optionItem.userId
                      ) || optionItem.userId === item.userId
                  )"
                  :key="item.userId"
                  :label="item.staffName"
                  :value="item.userId"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="驳回原因"
              :prop="`rejectItems.${index}.rejectReason`"
              :rules="rules.rejectReason"
            >
              <el-input
                v-model="item.rejectReason"
                type="textarea"
                placeholder="请输入驳回原因"
                :autosize="{ minRows: 4, maxRows: 4 }"
                maxlength="500"
                show-word-limit
              ></el-input>
            </el-form-item>
          </div>
          <el-form-item
            v-if="form.suggestionItems.length > form.rejectItems.length"
          >
            <el-button icon="el-icon-plus" type="text" @click="addRejectUser()"
              >新增责任单位人员</el-button
            >
          </el-form-item>
          <div class="submitArea">
            <el-button type="primary" @click="auditRejectSubmit()"
              >提交</el-button
            >
            <el-button plain @click="dialogVisible = false">取消</el-button>
          </div>
        </el-form>
      </el-dialog>
    </div>
  </kd-container>
</template>

<style scoped lang="scss"></style>
<script>
import { baseURL } from "../../util/url";
import { requestSubmitAudit } from "../../api/feedback";
import { requestSubmitAuditKD } from "@/api/feedbackKD";
import KdAuditPassDialog from "./kdAuditPassDialog.vue";

/**
 * 17.2-QE验证并上传断点信息
 */
export default {
  name: "kdQeCheckAndUploadBreakPointInfoAudit",
  components: { KdAuditPassDialog },
  props: {
    taskId: String,
    questionId: String,
    taskDefKey: String,
    suggestionItems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      header: {
        satoken: sessionStorage.getItem("token"),
      },
      imAction: "/manage/staff/upload?fileType=auditResource",
      dialogVisible: false,
      auditPassDialogVisible: false,
      userOptions: [],
      form: {
        suggestionItems: [
          {
            userId: "",
            provisionalMeasures: "",
            hasReasonAnalystMaterial: "",
            practicalBreakpointTime: "",
            reasonAnalyst: "",
            checkStatusInfo: "",
            checkStatusInfoFiles: [],
            provisionalMeasuresFile: [],
            reasonAnalystMaterial: "",
            planBreakpointTime: "",
            permanentSolution: "",
            permanentSolutionFile: [],
            finishStatusInfo: "",
            finishStatusInfoFiles: [],
            file: [],
          },
        ],
        rejectItems: [
          {
            userId: "",
            rejectReason: "",
          },
        ],
        handSuggestion: "",
        auditText: "",
      },
      rules: {
        permanentSolution: [
          {
            required: true,
            message: "永久方案不能为空",
            trigger: ["blur", "change"],
          },
        ],
        planBreakpointTime: [
          {
            required: true,
            message: "实际断点时间不能为空",
            trigger: ["blur", "change"],
          },
        ],
        finishStatusInfo: [
          {
            required: true,
            message: "完成情况不能为空",
            trigger: ["blur", "change"],
          },
        ],
        practicalBreakpointTime: [
          {
            required: true,
            message: "实际断点时间不能为空",
            trigger: ["blur"],
          },
        ],
        checkStatusInfo: [
          { required: true, message: "验证情况不能为空", trigger: ["blur"] },
        ],
        userId: [
          {
            required: true,
            message: "驳回责任单位人员不能为空",
            trigger: ["blur", "change"],
          },
        ],
        rejectReason: [
          {
            required: true,
            message: "驳回原因不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  watch: {
    hasTempSolution: function (val) {
      this.$emit("hasTempSolution", val);
    },
  },
  methods: {
    auditPassBtClick() {
      this.$refs["formRef"].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)) {
          return;
        }
        this.auditPassDialogVisible = true;
      });
    },
    onAuditPassConfirm(auditText) {
      let formData = {
        nowTaskId: this.taskId,
        questionId: this.questionId,
        taskDefKey: this.taskDefKey,
        auditText: auditText,
        reasonAnalystDatas: this.form.suggestionItems,
        variables: {
          approval: true,
        },
      };
      requestSubmitAuditKD(formData).then((res) => {
        if (res.status == "0") {
          this.$DonMessage.success("审批通过!");
          this.backRouterPath();
        }else {
          this.$DonMessage.error(res.message);
        }
      });
    },
    auditRejectBtClick() {
      this.dialogVisible = true;
      this.form.rejectItems= [
        {
          userId: "",
          rejectReason: "",
        }
      ];
      this.$nextTick(() => {
        this.$refs.rejectFormRef?.resetFields();
      });
    },
    addRejectUser() {
      if (this.form.rejectItems.length > this.form.suggestionItems.length) {
        this.$DonMessage.warning("添加驳回数量超过上限！");
        return;
      }
      this.form.rejectItems.push({
        userId: "",
        rejectReason: "",
      });
    },
    delRejectUser(index) {
      this.form.rejectItems.splice(index, 1);
    },
    auditRejectSubmit() {
      this.$refs["rejectFormRef"].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)) {
          return;
        }
        let formData = {
          nowTaskId: this.taskId,
          questionId: this.questionId,
          taskDefKey: this.taskDefKey,
          auditText: this.form.rejectReason,
          variables: {
            approval: false,
          },
          rejectItems: this.form.rejectItems,
        };
        requestSubmitAuditKD(formData).then((res) => {
          if (res.status == "0") {
            this.$DonMessage.success("驳回成功!");
            this.backRouterPath();
            this.dialogVisible = false;
          } else {
            this.$DonMessage.error(res.message);
          }
        });
      });
    },
  },
  mounted() {
    if (this.suggestionItems) {
      this.userOptions = this.suggestionItems;
      this.form.suggestionItems = this.suggestionItems;
    }
  },
};
</script>
